import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../../lib/api";
import { Button } from "../ui/button";

export function NoManuscript() {
  const { id } = useParams();
  const [, setParams] = useSearchParams();
  const [ups, setUps] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => { if (id) api.get(`/books/${id}/uploads`).then((r) => setUps(r.data.filter((u) => u.kind === "manuscript" && u.extraction?.sections?.length))).catch(() => {}); }, [id]);
  const imp = async (u) => {
    const hasErr = u.extraction.warnings?.some((w) => w.level === "error");
    if (hasErr && !window.confirm("This file had extraction errors. Import it anyway?")) return;
    setBusy(u.id);
    try { const { data } = await api.post(`/uploads/${u.id}/import`, { acknowledge_warnings: hasErr }); toast.success(`Imported as version ${data.number}`); window.dispatchEvent(new Event("book-reload")); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <div className="panel p-12 text-center" data-testid="no-manuscript">
      <FileText className="mx-auto text-amber-500 mb-4" />
      <p className="font-display text-2xl mb-2">No manuscript yet</p>
      {ups.length > 0 ? (
        <div className="max-w-md mx-auto text-left mt-4 space-y-2" data-testid="no-manuscript-uploads">
          <p className="text-sm text-slate-400 text-center mb-3">You've uploaded {ups.length === 1 ? "a manuscript" : "manuscripts"} — import one to use it in every tool.</p>
          {ups.map((u) => (
            <div key={u.id} className="flex items-center gap-3 border border-slate-800 rounded-lg px-3 py-2">
              <div className="min-w-0 flex-1"><p className="text-sm text-slate-100 truncate">{u.filename}</p><p className="text-[11px] text-slate-500">~{u.extraction.word_count.toLocaleString()} words · {fmtDate(u.created_at)}</p></div>
              <Button size="sm" onClick={() => imp(u)} disabled={!!busy} className="bg-amber-600 hover:bg-amber-500" data-testid={`quick-import-${u.id}`}>{busy === u.id ? "Importing…" : "Import"}</Button>
            </div>
          ))}
        </div>
      ) : <p className="text-sm text-slate-400 mb-6">Upload a file and import it to create version 1.</p>}
      <Button variant={ups.length ? "outline" : "default"} onClick={() => setParams({ tab: "upload" })} className={ups.length ? "mt-5 border-slate-700" : "bg-amber-600 hover:bg-amber-500"} data-testid="go-upload-button">{ups.length ? "Upload a different file" : "Upload manuscript"}</Button>
    </div>
  );
}
